import { createSelector } from 'reselect';
const selectComments = state => state.comments;

export const selectVideoComments = createSelector(
  selectComments,
  ({ comments }) => comments
);
